import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getPreferences, updatePreferences, getProfile, updateProfile, changePassword } from '@/services/settings.api';
import { showSuccess, showError } from '@/utils/toast';

export function usePreferences() {
  return useQuery({
    queryKey: ['preferences'],
    queryFn: getPreferences,
  });
}

export function useUpdatePreferences() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updatePreferences,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['preferences'] }); showSuccess(t('common.success')); },
    onError: () => showError(t('common.error')),
  });
}

export function useProfile() {
  return useQuery({
    queryKey: ['profile'],
    queryFn: getProfile,
  });
}

export function useUpdateProfile() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateProfile,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['profile'] }); showSuccess(t('settings.profileSaved')); },
    onError: () => showError(t('common.error')),
  });
}

export function useChangePassword() {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => showSuccess(t('settings.passwordChanged')),
    onError: () => showError(t('common.error')),
  });
}
